import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AdminLogin.css';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if already logged in
    checkAuthStatus();
  }, []);  const checkAuthStatus = async () => {
    try {
      const response = await fetch('/admin/auth-check.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ action: 'status' }),
        credentials: 'include'
      });
      
      // Debug: Log response details
      console.log('Auth check response status:', response.status);
      console.log('Auth check response headers:', Object.fromEntries(response.headers.entries()));
      
      const responseText = await response.text();
      console.log('Auth check raw response:', responseText);
      
      // Try to parse as JSON
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        console.error('Failed to parse auth check response as JSON:', parseError);
        console.error('Response was:', responseText);
        throw new Error('Server returned invalid response. Please check if .htaccess rules are working.');
      }
      
      if (data.isAuthenticated) {
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      setError('Connection error: ' + error.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {      const response = await fetch('/admin/login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'login',
          username: credentials.username,
          password: credentials.password
        }),
        credentials: 'include'
      });

      // Debug: Log response details
      console.log('Login response status:', response.status);
      console.log('Login response headers:', Object.fromEntries(response.headers.entries()));
      
      const responseText = await response.text();
      console.log('Login raw response:', responseText);
      
      // Try to parse as JSON
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        console.error('Failed to parse login response as JSON:', parseError);
        console.error('Response was:', responseText);
        throw new Error('Server returned invalid response. This usually means .htaccess rules are not working or PHP files are not accessible.');
      }

      if (data.success) {
        // Store admin session in localStorage
        localStorage.setItem('adminAuthenticated', 'true');
        localStorage.setItem('adminUser', JSON.stringify(data.admin));
        navigate('/admin/dashboard');
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Connection error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-logo">
          <h1>LTF Life Changer</h1>
          <p>Admin Dashboard</p>
        </div>
        
        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            className="admin-login-btn"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
          
          {error && <div className="admin-error">{error}</div>}
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
